export default __webpack_public_path__ + "static/media/mail.fcb41cd9.svg";